module.exports = __webpack_public_path__ + "img/图四.25eac1c4.jpg";